import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const MarketplacePage = lazy(() => import('../pages/marketplace/page'));
const SourcingDirectoryPage = lazy(() => import('../pages/sourcing-directory/page'));
const LearningHubPage = lazy(() => import('../pages/learning-hub/page'));
const WaterManagementGuidePage = lazy(() => import('../pages/learning-hub/guides/water-management/page'));
const RenewableEnergyGuidePage = lazy(() => import('../pages/learning-hub/guides/renewable-energy/page'));
const CarbonAccountingGuidePage = lazy(() => import('../pages/learning-hub/guides/carbon-accounting/page'));
const EnergyManagementGuidePage = lazy(() => import('../pages/learning-hub/guides/energy-management/page'));
const WasteManagementGuidePage = lazy(() => import('../pages/learning-hub/guides/waste-management/page'));
const ESGComplianceGuidePage = lazy(() => import('../pages/learning-hub/guides/esg-compliance/page'));
const CertificationsGuidePage = lazy(() => import('../pages/learning-hub/guides/certifications/page'));
const SupplyChainGuidePage = lazy(() => import('../pages/learning-hub/guides/supply-chain/page'));
const CultureGuidePage = lazy(() => import('../pages/learning-hub/guides/culture/page'));
const ForBuyersPage = lazy(() => import('../pages/for-buyers/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const DocumentationPage = lazy(() => import('../pages/documentation/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const RequestDemoPage = lazy(() => import('../pages/request-demo/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const ManufacturerRegistrationPage = lazy(() => import('../pages/manufacturer-registration/page'));
const BuyerRegistrationPage = lazy(() => import('../pages/buyer-registration/page'));
const ManufacturerDashboardPage = lazy(() => import('../pages/manufacturer-dashboard/page'));
const BuyerDashboardPage = lazy(() => import('../pages/buyer-dashboard/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />,
  },
  {
    path: '/marketplace',
    element: <MarketplacePage />,
  },
  {
    path: '/sourcing-directory',
    element: <SourcingDirectoryPage />,
  },
  {
    path: '/learning-hub',
    element: <LearningHubPage />
  },
  {
    path: '/learning-hub/guides/water-management',
    element: <WaterManagementGuidePage />
  },
  {
    path: '/learning-hub/guides/carbon-accounting',
    element: <CarbonAccountingGuidePage />
  },
  {
    path: '/learning-hub/guides/energy-management',
    element: <EnergyManagementGuidePage />
  },
  {
    path: '/learning-hub/guides/renewable-energy',
    element: <RenewableEnergyGuidePage />
  },
  {
    path: '/learning-hub/guides/waste-management',
    element: <WasteManagementGuidePage />
  },
  {
    path: '/learning-hub/guides/esg-compliance',
    element: <ESGComplianceGuidePage />
  },
  {
    path: '/learning-hub/guides/certifications',
    element: <CertificationsGuidePage />
  },
  {
    path: '/learning-hub/guides/supply-chain',
    element: <SupplyChainGuidePage />
  },
  {
    path: '/learning-hub/guides/culture',
    element: <CultureGuidePage />
  },
  {
    path: '/for-buyers',
    element: <ForBuyersPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '/documentation',
    element: <DocumentationPage />,
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />,
  },
  {
    path: '/request-demo',
    element: <RequestDemoPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/manufacturer-registration',
    element: <ManufacturerRegistrationPage />,
  },
  {
    path: '/buyer-registration',
    element: <BuyerRegistrationPage />,
  },
  {
    path: '/manufacturer-dashboard',
    element: <ManufacturerDashboardPage />,
  },
  {
    path: '/buyer-dashboard',
    element: <BuyerDashboardPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
